import common from './common';
import fieldValidation from './fieldValidation';
import invoiceManagement from './invoiceManagement';

const en = { common, invoiceManagement, fieldValidation };
export default en;
